import React, { createContext, useState, useContext, ReactNode } from "react"
import { setStorageVariable, getStorageVariable } from "../utils/storage"
import { STORAGE_DARK_MODE } from "../constants"

interface ThemeContextType {
  isDarkMode: boolean
  toggleTheme: (checked: boolean) => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const isDarkModeSetInStorage = getStorageVariable(STORAGE_DARK_MODE) === "true"
  const [isDarkMode, setDarkMode] = useState(isDarkModeSetInStorage)

  const toggleTheme = (checked: boolean) => {
    setDarkMode(checked)
    setStorageVariable(STORAGE_DARK_MODE, checked)
  }

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }
  return context
}
